import { Configuration } from "@socotec.io/user-management-sdk";
import { useOidcStore } from "vue3-oidc";

export const userManagementConfig = new Configuration({
  basePath: import.meta.env.VITE_APP_USER_MANAGEMENT_REST_API_URL,
  accessToken: () => `Bearer ${useOidcStore().state.value.token}`,
});

export async function fetchAll(client, func, filters = {}, limit = 1000) {
  let page = 1;
  // forcing a page size of 100 to avoid issues with very large page sizes
  const pageSize = Math.max(filters.pageSize ?? 0, 100);
  let allResults = [];
  let totalCount = null;
  while (true) {
    const { count, results } = await client[func]({
      ...filters,
      pageSize,
      page,
    });

    totalCount = count;
    allResults = allResults.concat(results);
    page += 1;

    if (allResults.length >= totalCount || allResults.length >= limit) {
      break;
    }
  }

  return { results: allResults };
}
